var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsRemove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_remove",
    transform: "translate(-588 -465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons_remove-2",
    "data-name": "icons_remove",
    d: "M9.561,5.02V3.49H21.793V5.018S9.561,5.02,9.561,5.02Zm0-1.531a1.53,1.53,0,0,0-1.53,1.532l1.53,0Zm13.316.449a1.518,1.518,0,0,0-1.083-.449V5.018l1.53,0A1.516,1.516,0,0,0,22.876,3.938ZM14.907,2.347h1.54V.817h-1.54v0a1.53,1.53,0,0,0-1.53,1.532S14.907,2.345,14.907,2.347Zm2.623-1.082A1.518,1.518,0,0,0,16.448.816V2.345l1.53,0A1.516,1.516,0,0,0,17.531,1.265Zm1.61,15.827H12.079L10.553,6.178l-1.585,0,1.609,11.516a1.14,1.14,0,0,0,1.123.972h7.818a1.142,1.142,0,0,0,1.123-.976L22.251,6.174l-1.584,0Z",
    transform: "translate(583.969 468.184)",
    fill: "#be2126"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bounding",
    width: 24,
    height: 24,
    transform: "translate(588 465)",
    fill: "none"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsRemove);
export default __webpack_public_path__ + "static/media/icons_remove.5e5e96b4.svg";
export { ForwardRef as ReactComponent };